// core
import { Injectable } from '@angular/core';
import { Event, RouterEvent, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

// material
import { MatDialog } from '@campfire-nx/material';

// components
import { HelpInterstitialComponent } from '../components/help-interstitial/help-interstitial.component';

type IntersitialDetails = {
  type: string;
  settings: {
    icon: string;
    time: number;
  };
  heading: string;
  subtext: string;
};

@Injectable({
  providedIn: 'root'
})
export class HelpInterstitialService {
  intersitialConfig = {
    position: { top: '0', left: '0' },
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    closeOnNavigation: true,
    hasBackdrop: false
  };
  popupConfig = {
    position: { top: '0' },
    maxWidth: '100%',
    closeOnNavigation: true,
    hasBackdrop: true
  };

  dialogRef: any = null;
  startTime: any = null;
  endTime: any = null;
  interstitialTime: any = null;

  constructor(public dialog: MatDialog, private router: Router) {
    this.router.events
      .pipe(filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }

        this.resetTimers();
      });
  }

  public open(interstitialDetails: IntersitialDetails) {
    this.startTime = new Date().getTime();
    this.interstitialTime = interstitialDetails.settings.time;

    this.dialogRef = this.dialog.open(HelpInterstitialComponent, {
      ...this.intersitialConfig,
      panelClass: ['helpflow-interstitial-container'],
      data: { ...interstitialDetails, time: this.interstitialTime }
    });
  }

  public close(): void {
    let closeTime = 0;

    if (this.startTime && this.interstitialTime) {
      this.endTime = new Date().getTime();
      const currentCounter = this.interstitialTime - (this.endTime - this.startTime);
      if (currentCounter > 0) {
        closeTime = currentCounter;
      }
    }

    setTimeout(() => {
      if (this.dialogRef) {
        this.dialogRef.close();
      }

      this.resetTimers();
    }, closeTime);
  }

  resetTimers() {
    this.startTime = null;
    this.endTime = null;
    this.interstitialTime = null;
  }
}
